import React from 'react'
import CrearCotizacion from '../CrearCotizacion'
import { useLocation } from 'react-router-dom'

function CartManager({ edit, clone }) {
  const location = useLocation()
  const currentPath = location.pathname

  currentPath.includes('cotizar_producto')
  return (
    <>
      <CrearCotizacion
        edit={currentPath.includes('edit_cart')}
        clone={currentPath.includes('/clonar_cotizacion')}
      />
    </>
  )
}

export default CartManager
